<template>
  <div class="sidebar sidebar-doorder">
    <div class="">
      <div class="user" style="z-index: 3">
        <div class="photo photo-full text-center mb-3">
          <img src="@/assets/images/doorder/Logo.png" id="adminNavLogoImg" />
        </div>
      </div>
      <div class="sidebar-wrapper">
        <ul class="nav" v-if="user_type == 'retailer' || user_type == 'user'">
          <li class="nav-item">
            <router-link to="/doorder/dashboard" class="nav-link d-flex"
              ><img
                class="my-nav-icon my-nav-icon-grey"
                src="@/assets/images/doorder/dashboard-grey.png"
                alt=""
              />
              <img
                class="my-nav-icon my-nav-icon-top"
                src="@/assets/images/doorder/dashboard-yellow.png"
                alt=""
              />
              <p>Dashboard</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/doorder/add_order" class="nav-link d-flex"
              ><img
                class="my-nav-icon my-nav-icon-grey"
                src="@/assets/images/doorder/add-order-grey.png"
                alt=""
              />
              <img
                class="my-nav-icon my-nav-icon-top"
                src="@/assets/images/doorder/add-order-yellow.png"
                alt=""
              />
              <p>New Order</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/doorder/orders" class="nav-link d-flex"
              ><img
                class="my-nav-icon my-nav-icon-grey"
                src="@/assets/images/doorder/orders-grey.png"
                alt=""
              />
              <img
                class="my-nav-icon my-nav-icon-top"
                src="@/assets/images/doorder/orders-yellow.png"
                alt=""
              />
              <p>Orders Table</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/doorder/orders_history" class="nav-link d-flex"
              ><img
                class="my-nav-icon my-nav-icon-grey"
                src="@/assets/images/doorder/history-grey.png"
                alt=""
              />
              <img
                class="my-nav-icon my-nav-icon-top"
                src="@/assets/images/doorder/history-yellow.png"
                alt=""
              />
              <p>History</p>
            </router-link>
          </li>
          <li class="nav-item">
            <a class="nav-link d-flex" @click="logout"
              ><img
                class="my-nav-icon my-nav-icon-grey"
                src="@/assets/images/doorder/logout-grey.png"
                alt=""
              />
              <img
                class="my-nav-icon my-nav-icon-top"
                src="@/assets/images/doorder/logout-yellow.png"
                alt=""
              />
              <p>Logout</p>
            </a>
          </li>
        </ul>
        <ul class="nav" v-if="user_type == 'admin'">
          <li class="nav-item">
            <router-link to="/doorder/dashboard" class="nav-link d-flex"
              ><img
                class="my-nav-icon my-nav-icon-grey"
                src="@/assets/images/doorder/dashboard-grey.png"
                alt=""
              />
              <img
                class="my-nav-icon my-nav-icon-top"
                src="@/assets/images/doorder/dashboard-yellow.png"
                alt=""
              />
              <p>Dashboard</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/doorder/orders" class="nav-link d-flex"
              ><img
                class="my-nav-icon my-nav-icon-grey"
                src="@/assets/images/doorder/orders-grey.png"
                alt=""
              />
              <img
                class="my-nav-icon my-nav-icon-top"
                src="@/assets/images/doorder/orders-yellow.png"
                alt=""
              />
              <p>Orders Table</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/doorder/retailers" class="nav-link d-flex"
              ><img
                class="my-nav-icon my-nav-icon-grey"
                src="@/assets/images/doorder/retailers-grey.png"
                alt=""
              />
              <img
                class="my-nav-icon my-nav-icon-top"
                src="@/assets/images/doorder/retailers-yellow.png"
                alt=""
              />
              <p>Retailers</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/doorder/drivers" class="nav-link d-flex"
              ><img
                class="my-nav-icon my-nav-icon-grey"
                src="@/assets/images/doorder/drivers-grey.png"
                alt=""
              />
              <img
                class="my-nav-icon my-nav-icon-top"
                src="@/assets/images/doorder/drivers-yellow.png"
                alt=""
              />
              <p>Deliverers</p>
            </router-link>
          </li>
          <li class="nav-item">
            <a
              class="nav-link collapsed d-flex"
              v-b-toggle.requestsList
              aria-expanded="false"
            >
              <img
                class="my-nav-icon my-nav-icon-grey"
                src="@/assets/images/doorder/requests-grey.png"
                alt=""
              />
              <img
                class="my-nav-icon my-nav-icon-top"
                src="@/assets/images/doorder/requests-yellow.png"
                alt=""
              />
              <p>Requests <i class="fas fa-angle-down"></i></p>
            </a>
            <b-collapse id="requestsList">
              <ul class="nav">
                <li class="nav-item">
                  <router-link to="/doorder/retailer/requests">
                    <span class="sidebar-mini">RR</span>
                    <span class="sidebar-normal"> Retailers Requests </span>
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/doorder/retailer/requests">
                    <span class="sidebar-mini">DR</span>
                    <span class="sidebar-normal"> Drivers Requests </span>
                  </router-link>
                </li>
              </ul>
            </b-collapse>
          </li>

          <li class="nav-item">
            <a
              class="nav-link collapsed d-flex"
              v-b-toggle.invoiceList
              aria-expanded="false"
            >
              <img
                class="my-nav-icon my-nav-icon-grey"
                src="@/assets/images/doorder/invoice-grey.png"
                alt=""
              />
              <img
                class="my-nav-icon my-nav-icon-top"
                src="@/assets/images/doorder/invoice-yellow.png"
                alt=""
              />
              <p>Invoice <i class="fas fa-angle-down"></i></p>
            </a>
            <b-collapse id="invoiceList">
              <ul class="nav">
                <li class="nav-item">
                  <router-link to="/doorder/invoice/retailers">
                    <span class="sidebar-mini">RI</span>
                    <span class="sidebar-normal"> Retailers</span>
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/doorder/invoice/drivers">
                    <span class="sidebar-mini">DI</span>
                    <span class="sidebar-normal"> Drivers</span>
                  </router-link>
                </li>
              </ul>
            </b-collapse>
          </li>

          <li class="nav-item">
            <router-link to="/doorder/orders_history" class="nav-link d-flex"
              ><img
                class="my-nav-icon my-nav-icon-grey"
                src="@/assets/images/doorder/history-grey.png"
                alt=""
              />
              <img
                class="my-nav-icon my-nav-icon-top"
                src="@/assets/images/doorder/history-yellow.png"
                alt=""
              />
              <p>History</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/doorder/dashboard_metrics" class="nav-link d-flex"
              ><img
                class="my-nav-icon my-nav-icon-grey"
                src="@/assets/images/doorder/metrics-grey.png"
                alt=""
              />
              <img
                class="my-nav-icon my-nav-icon-top"
                src="@/assets/images/doorder/metrics-yellow.png"
                alt=""
              />
              <p>Metrics</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/doorder/payment_logs" class="nav-link d-flex"
              ><img
                class="my-nav-icon my-nav-icon-grey"
                src="@/assets/images/doorder/payment-log-grey.png"
                alt=""
              />
              <img
                class="my-nav-icon my-nav-icon-top"
                src="@/assets/images/doorder/payment-log-yellow.png"
                alt=""
              />
              <p>Payment Logs</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/doorder/settings" class="nav-link d-flex"
              ><img
                class="my-nav-icon my-nav-icon-grey"
                src="@/assets/images/doorder/settings-grey.png"
                alt=""
              />
              <img
                class="my-nav-icon my-nav-icon-top"
                src="@/assets/images/doorder/settings-yellow.png"
                alt=""
              />
              <p>Settings</p>
            </router-link>
          </li>
          <li class="nav-item">
            <a class="nav-link d-flex" @click="logout"
              ><img
                class="my-nav-icon my-nav-icon-grey"
                src="@/assets/images/doorder/logout-grey.png"
                alt=""
              />
              <img
                class="my-nav-icon my-nav-icon-top"
                src="@/assets/images/doorder/logout-yellow.png"
                alt=""
              />
              <p>Logout</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- <template #footer="{ hide }">
      <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
        <strong class="mr-auto">Footer</strong>
        <b-button size="sm" @click="hide">Close</b-button>
      </div>
    </template> -->
  </div>
</template>
    
<script>
export default {
  name: "SidebarDoorder",
  data() {
    return {
      user_type: null,
    };
  },
  mounted() {
    let user = JSON.parse(window.localStorage.getItem("user"));
    this.user_type = user.type;
    console.log(user.type);
  },
  methods: {
    logout() {
      console.log("logoutt doorder admin");
      //  console.log(this.$children)
      // this.$confirm({
      //   title: 'Are you sure?',
      //   message: 'Are you sure you want to logout?',
      //   button: {
      //     yes: 'Yes',
      //     no: 'Cancel'
      //   },
      //   callback: confirm => {
      //     if (confirm) {
      localStorage.removeItem("user");
      localStorage.removeItem("customer");
      //  App.isLogin = false;
      this.$router
        .go({ name: "DoorderLogin", params: { type: "admin" } })
        .catch(() => {});
      // console.log(localStorage);
      //     }
      //   }
      // })
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/partials/admin_sidebar_doorder.vue